import dataCaptureLabsLogo from "../DclSalesFunnel__src_imports_Color-logo-no-background-white-ring-scaled__1_.png";
import fitPocketLogo from "../FitPocket-GitHub-Clean__static_img_fitpocket-logo.png";
import vantaraLogo from "../medilogix-outbound-caller__static_media_vantara-loader_2.png";
import mediLogixLogo from "../medilogix-outbound-caller_DEPLOY__cropped-noBgColor-scaled.png";
import ironDZignLogo from "../iron-d-zign__public_favicon.png";

const CUSTOMER_LOGOS = [
  {
    name: "Data Capture Labs",
    href: "https://datacapturelabs.com/",
    src: dataCaptureLabsLogo,
    alt: "Data Capture Labs logo",
    width: 250,
    height: 250,
  },
  {
    name: "FitPocket",
    href: "https://fitpocket.fitness/#pricing",
    src: fitPocketLogo,
    alt: "FitPocket logo",
    width: 1448,
    height: 1086,
  },
  {
    name: "Vantara",
    href: "https://www.ai-vantara.com/",
    src: vantaraLogo,
    alt: "Vantara logo",
    width: 1024,
    height: 1024,
  },
  {
    name: "MediLogix",
    href: "https://www.medilogix.io/",
    src: mediLogixLogo,
    alt: "MediLogix logo",
    width: 2560,
    height: 1667,
  },
  {
    name: "Iron D-Zign",
    href: "https://irondzign.com/",
    src: ironDZignLogo,
    alt: "Iron D-Zign logo",
    width: 256,
    height: 256,
    frameClassName: "is-square-logo is-iron-dzign",
  },
];

export default function TrustedBy() {
  return (
    <section className="trusted-by-section" aria-label="Trusted by customers">
      <div className="container-edge trusted-by-inner">
        <p className="trusted-by-label">Trusted by teams building with ForgeLayer</p>
        <div className="trusted-logo-grid">
          {CUSTOMER_LOGOS.map((logo) => (
            <a
              className="trusted-logo-card"
              href={logo.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Visit ${logo.name}`}
              key={logo.name}
            >
              <span className={`trusted-logo-frame ${logo.frameClassName || ""}`.trim()}>
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="trusted-logo-img"
                  width={logo.width}
                  height={logo.height}
                  loading="lazy"
                  decoding="async"
                />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
